module.exports = __webpack_public_path__ + "img/events-slothtech.a16e887d.jpg";